module.exports = __webpack_public_path__ + "img/arrow-right-encircled.0aa2cfb9.svg";